export const SystemMetricsQueryKey = {
	GetEcsServiceCpuMem: 'GetEcsServiceCpuMem',
	GetTaskMetrics: 'GetTaskMetrics',
} as const
